<template>
  <div>
    <div class="mb-5">
      <div class="page-title">สร้างข้อมูลโครงการหลัก</div>
    </div>
    <!--  Form  -->
    <div class="d-flex flex-column gap-16 mb-12">
      <divcard>
        <div class="card-part">
          <div class="txt-head black--text mb-3">ข้อมูลโครงการหลัก</div>

          <div>
            <div class="flex-center gap-16">
              <div class="flex xs3">
                <div class="mb-1 black--text">ปีงบประมาณ</div>
                <SelectBox
                  v-if="isYearSelect"
                  theme="3"
                  :value="form.fiscal_year"
                  :placeholder="'โปรดระบุ'"
                  :items="yearList"
                  item-text="name"
                  item-value="id"
                  @onChange="setFormField('fiscal_year', $event)"
                ></SelectBox>
                <TextField
                  v-else 
                  theme="3"
                  readonly
                  :value="form.fiscal_year"
                ></TextField>
              </div>

              <div class="flex xs9">
                <div class="mb-1 black--text">โครงการหลัก</div>
                <TextField
                  theme="3"
                  :value="form.name"
                  @onChange="setFormField('name', $event)"
                  :readonly="previewCheck"
                ></TextField>
              </div>
            </div>

            <div class="flex-center gap-16">
              <div class="flex xs3">
                <div class="mb-1 black--text">วันที่เปิดรับโครงการ</div>
                <DatePicker
                  :value="startDate"
                  @onInput="startDate = $event"
                  :disabled="previewCheck"
                ></DatePicker>
              </div>

              <div class="flex xs3">
                <div class="mb-1 black--text">เวลา</div>
                <TimePicker
                  :value="startTime"
                  @onInput="startTime = $event"
                  :disabled="previewCheck"
                ></TimePicker>
              </div>

              <div class="flex xs3">
                <div class="mb-1 black--text">ถึง</div>
                <DatePicker
                  :value="endDate"
                  @onInput="endDate = $event"
                  :disabled="previewCheck"
                ></DatePicker>
              </div>

              <div class="flex xs3">
                <div class="mb-1 black--text">เวลา</div>
                <TimePicker
                  :value="endTime"
                  @onInput="endTime = $event"
                  :disabled="previewCheck"
                ></TimePicker>
              </div>
            </div>

            <div class="flex-center gap-16">
              <div class="flex xs3">
                <div class="mb-1 black--text">วันที่พิจารณาโครงการ</div>
                <DatePicker
                  :value="form.consider_date"
                  @onInput="setFormField('consider_date', $event)"
                  :disabled="previewCheck"
                ></DatePicker>
              </div>

              <div class="flex xs9">
                <div class="mb-1 black--text d-flex">
                  งบประมาณ
                  <div v-if="form.budget" class="ml-3 theme-color-eight">
                    ({{ formatNumber(form.budget, 2) }})
                  </div>
                </div>
                <TextField
                  theme="3"
                  input-type="decimal"
                  :value="form.budget"
                  @onChange="setFormField('budget', $event)"
                  :readonly="previewCheck"
                ></TextField>
              </div>
            </div>
          </div>
        </div>
      
        <!-- <div class="card-part">
          <div class="d-flex align-center gap-12">
            <div class="mb-1 black--text">
              สถานะ
              <span class="theme-color-seven">*</span>
            </div>
            <SwitchInset
                :input-value="form.status"
                true-value="Active"
                false-value="Inactive"
                v-if="!$route.query.preview"
                @onChange="setFormField('status', $event)"
            ></SwitchInset>
            <div>{{ form.status === 'Active' ? 'เปิดรับโครงการ' : 'ปิดรับโครงการ' }}</div>
          </div>
        </div> -->
      </divcard>
      <!--  Other Form  -->
        <FormIRTC
      v-if="irtcFormActive"
      :master-data="irtcMasterData"
      :previewCheck="previewCheck"
      :status="irtcStatus"
      :disabled="manageBuildingStatus === 'Active' || rspManagementStatus === 'Active' || form.status === 'Active' || form.status === 'Inactive'"
      @update:status="updateStatus('irtcStatus', $event)"
    ></FormIRTC>

    <FormCollaborative
      v-if="collaborativeFormActive"
      :master-data="collaborativeMasterData"
      :previewCheck="previewCheck"
      :status="collaborativeStatus"
      :disabled="manageBuildingStatus === 'Active' || rspManagementStatus === 'Active'|| form.status === 'Active' || form.status === 'Inactive'"
      @update:status="updateStatus('collaborativeStatus', $event)"
    ></FormCollaborative>

    <FormSTI
      v-if="stiFormActive"
      :master-data="stiMasterData"
      :previewCheck="previewCheck"
      :status="stiStatus"
      :disabled="manageBuildingStatus === 'Active' || rspManagementStatus === 'Active'|| form.status === 'Active' || form.status === 'Inactive'"

      @update:status="updateStatus('stiStatus', $event)"
    ></FormSTI>

    <FormServicePlatform
      v-if="servicePlatformFormActive"
      :master-data="servicePlatformMasterData"
      :previewCheck="previewCheck"
      :status="servicePlatformStatus"
      :disabled="manageBuildingStatus === 'Active' || rspManagementStatus === 'Active'|| form.status === 'Active' || form.status === 'Inactive'"
      @update:status="updateStatus('servicePlatformStatus', $event)"
    ></FormServicePlatform>
    <FormManageBuilding
      v-if="manageBuildingFormActive"
      :master-data="manageBuildingMasterData"
      :previewCheck="previewCheck"
      :status="manageBuildingStatus"
      :disabled="rspManagementStatus === 'Active' || servicePlatformStatus === 'Active' || collaborativeStatus === 'Active' ||irtcStatus === 'Active' || stiStatus === 'Active'|| form.status === 'Active' || form.status === 'Inactive'"
      @update:status="updateStatus('manageBuildingStatus', $event)"
    ></FormManageBuilding>
    <FormRSPManagement
      v-if="rspManagementFormActive"
      :master-data="rspManagementMasterData"
      :previewCheck="previewCheck"
      :status="rspManagementStatus"
      :disabled="manageBuildingStatus === 'Active' || servicePlatformStatus === 'Active' || collaborativeStatus === 'Active' ||irtcStatus === 'Active' || stiStatus === 'Active'|| form.status === 'Active' || form.status === 'Inactive'"
      @update:status="updateStatus('rspManagementStatus', $event)"
    ></FormRSPManagement>
    </div>

    <!-- Action buttons -->
    <div class="d-flex justify-space-between">
      <Button theme="2" @onClick="$router.push({ name: 'MainProject' })"
        >ยกเลิก</Button
      >

      <div class="flex-center" v-if="!$route.query.preview">
        <Button
          :disabled="form.status === 'Active'"
          theme="4"
          min-width="120px"
          @onClick="save('Draft')"
        >
          บันทึกฉบับร่าง
        </Button>
        <Button min-width="120px" @onClick="save('Active')">บันทึก</Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../../components/input/Button";
import TextField from "../../components/input/TextField";
import TextArea from "../../components/input/TextArea";
import AutoBox from "../../components/input/AutoBox";
import SwitchInset from "../../components/input/SwitchInset";
import DatePicker from "../../components/input/DatePicker";
import TimePicker from "../../components/input/TimePicker";
import FormIRTC from "./MainProject/FormIRTC";
import FormCollaborative from "./MainProject/FormCollaborative";
import FormManageBuilding from "./MainProject/FormManageBuilding";
import FormRSPManagement from "./MainProject/FormRSPManagement";
import FormSTI from "./MainProject/FormSTI";
import FormServicePlatform from "./MainProject/FormServicePlatform";
import { eventBus, formatNumber } from "../../plugins/global-funcs";
import SelectBox from "@/components/input/SelectBox";

export default {
  name: "MainProjectForm",
  components: {
    Button,
    TextField,
    TextArea,
    SwitchInset,
    DatePicker,
    TimePicker,
    AutoBox,
    FormIRTC,
    FormCollaborative,
    FormSTI,
    FormServicePlatform,
    FormManageBuilding,
    FormRSPManagement,
    SelectBox
  },
  data() {
    return {
      formatNumber,
      form: {
        status: "",
      },
      
      irtcForm: {},
      collaborativeForm: {},
      stiForm: {},
      servicePlatformForm: {},
      manageBuildingForm: {},
      rspManagementForm: {},
      irtcFormActive: false,
      collaborativeFormActive: false,
      stiFormActive: false,
      servicePlatformFormActive: false,
      manageBuildingFormActive: false,
      rspManagementFormActive: false,
      irtcMasterData: {},
      collaborativeMasterData: {},
      stiMasterData: {},
      servicePlatformMasterData: {},
      manageBuildingMasterData: {},
      rspManagementMasterData: {},
      irtcStatus: 'Inactive',
      collaborativeStatus: 'Inactive',
      stiStatus: 'Inactive',
      servicePlatformStatus: 'Inactive',
      manageBuildingStatus: 'Inactive',
      rspManagementStatus: 'Inactive',
      startDate: undefined,
      endDate: undefined,
      startTime: undefined,
      endTime: undefined,
      testPayload: {},
      previewCheck: false,
      yearList: [],
      isYearSelect: [],
    };
  },
  async created() {
    await this.getMasterData();
    await this.retrieveForms();

    if (this.$route.params.id) {
      await this.retrieveMainProject();
    }
    if(this.$route.query.preview){
      this.previewCheck = true
    }

    this.getIsYearSelect();
    this.generateYearList();
  },
  methods: {
    async save(status) {
      this.requestForm();
      const plans = [
        ...(this.servicePlatformStatus === 'Active' ? [{ plan_master_id: 1, ...this.servicePlatformForm }] : []),
        ...(this.irtcStatus === 'Active' ? [{ plan_master_id: 2, ...this.irtcForm }] : []),
        ...(this.stiStatus === 'Active' ? [{ plan_master_id: 3, ...this.stiForm }] : []),
        ...(this.collaborativeStatus === 'Active' ? [{ plan_master_id: 4, ...this.collaborativeForm }] : []),
        ...(this.manageBuildingStatus === 'Active' ? [{ plan_master_id: 5, ...this.manageBuildingForm }] : []),
        ...(this.rspManagementStatus === 'Active' ? [{ plan_master_id: 6, ...this.rspManagementForm }] : []),
      ];
      const startDate = this.startDate ? this.startDate : new Date().toISOString().split("T")[0];
      const endDate = this.endDate ? this.endDate : new Date().toISOString().split("T")[0];
      const startTime = this.startTime ? this.startTime : "00:00";
      const endTime = this.endTime ? this.endTime : "23:59";

      let payload = {
        main_project: {
          fiscal_year: this.form.fiscal_year,
          name: this.form.name,
          start_date: startDate + " " + startTime,
          end_date: endDate + " " + endTime,
          consider_date: this.form.consider_date,
          budget: this.form.budget,
          status: status,
        },
        plans: plans
      };

      //check each plans has attachments or not
      if (payload.plans?.length > 0) {
        for (let i = 0; i < payload.plans.length; i++) {
          if (payload.plans[i].attachments?.length > 0) {
            for (let j = 0; j < payload.plans[i].attachments.length; j++) {
              if (payload.plans[i].attachments[j] instanceof File) {
                payload.plans[i].attachments[j] = await this.uploadFile(
                  payload.plans[i].attachments[j]
                );
              }
            }
          }
        }
      }

      console.log("payload", payload);

      let res;
      if (this.$route.params.id) {
        this.testPayload = payload;
        // payload.plans = payload.plans.filter((plan) => plan.id);
        console.log("payload to update : ", payload);
        payload.id = this.$route.params.id;
        res = await this.$apiFire(
          "MainProject/updateMainProject",
          payload,
          true
        );
        console.log("update Success", res);
      } else {
        this.testPayload = payload;
        console.log("payload to save : ", payload);
        res = await this.$apiFire(
          "MainProject/storeMainProject",
          payload,
          true
        );
        console.log(res);
      }

      if (res && (res.message == "สร้างโครงการหลักสำเร็จ" || res.message == "แก้ไขโครงการหลักสำเร็จ")) {
        this.$store.commit("General/setModal", {
          title: "เสร็จสิ้น!",
          theme: "success",
          text: res.message,
          showCancel: false,
          action: () => this.$router.push({ name: "MainProject" }),
        });
      } else {
        this.$store.commit("General/setModal", {
          title: "ข้อมูลไม่ครบถ้วน ?",
          theme: "warning",
          text: typeof res === "object" ? res.join(", ") : res,
          showCancel: false,
          buttonText: "ตกลง",
        });
      }
    },
    updateStatus(key, value) {
      console.log("updateStatus", key, value);
      
      this[key] = value;
      const activeKeys = ['irtcStatus', 'collaborativeStatus', 'stiStatus', 'servicePlatformStatus', 'manageBuildingStatus', 'rspManagementStatus'];
      const normalKeys = ['irtcStatus', 'collaborativeStatus', 'stiStatus', 'servicePlatformStatus'];
      const exclusiveKeys = ['manageBuildingStatus', 'rspManagementStatus'];

      if (exclusiveKeys.includes(key) && value === 'Active') {
        activeKeys.forEach((activeKeys) => {
          if (activeKeys !== key) {
            this[activeKeys] = 'Inactive';
          }
        });
      }
      else if (normalKeys.includes(key) && value === 'Active'){
        exclusiveKeys.forEach((exclusiveKeys) => {
          if (exclusiveKeys !== key) {
            this[exclusiveKeys] = 'Inactive';
          }
        });
      }
    },
    setFormField(field, val) {
      this.form[field] = val;
      this.$forceUpdate();
    },
    retrieveForms() {
      // IRTC form
      eventBus.$on("mainProjectFormIRTCSend", (form) => {
        this.irtcForm = form;
        // keep in storage
        // this.$store.commit('CForm/setGeneralForm', this.irtcForm)
      });

      // Collaborative form
      eventBus.$on("mainProjectFormCollaborativeSend", (form) => {
        this.collaborativeForm = form;
        // keep in storage
        // this.$store.commit('CForm/setProjectForm', this.collaborativeForm)
      });

      // STI form
      eventBus.$on("mainProjectFormSTISend", (form) => {
        this.stiForm = form;
        // keep in storage
        // this.$store.commit('CForm/setPlanForm', this.stiForm)
      });

      // Service Platform form
      eventBus.$on("mainProjectFormServicePlatformSend", (form) => {
        this.servicePlatformForm = form;
        // keep in storage
        // this.$store.commit('CForm/setOOIForm', this.servicePlatformForm)
      });
      eventBus.$on("mainProjectFormManageBuildingSend", (form) => {
        this.manageBuildingForm = form;
        // keep in storage
        // this.$store.commit('CForm/setOOIForm', this.servicePlatformForm)
      });
      eventBus.$on("mainProjectFormRSPManagementSend", (form) => {
        this.rspManagementForm = form;
        // keep in storage
        // this.$store.commit('CForm/setOOIForm', this.servicePlatformForm)
      });
    },
    handleStatusUpdate(newStatus) {
    console.log('Updating irtcStatus:', newStatus); // Debug log
    this.irtcStatus = newStatus;
  },
    requestForm() {
      eventBus.$emit("mainProjectFormIRTC");
      eventBus.$emit("mainProjectFormCollaborative");
      eventBus.$emit("mainProjectFormSTI");
      eventBus.$emit("mainProjectFormServicePlatform");
      eventBus.$emit("mainProjectFormManageBuilding");
      eventBus.$emit("mainProjectFormRSPManagement");
    },
    async getMasterData() {
      let res = await this.$apiFire("MainProject/getMasterMainProject");
      console.log(res);
      if (res) {
        this.form.fiscal_year = res.fiscal_year;
        for (const x of res.plan_master) {
          switch (x.id) {
            case 1:
              if (x.is_active) {
                this.servicePlatformMasterData = x;
                this.servicePlatformFormActive = true;
              }
              break;
            case 2:
              if (x.is_active) {
                this.irtcMasterData = x;
                this.irtcFormActive = true;
              }
              break;
            case 3:
              if (x.is_active) {
                this.stiMasterData = x;
                this.stiFormActive = true;
              }
              break;
            case 4:
              if (x.is_active) {
                this.collaborativeMasterData = x;
                this.collaborativeFormActive = true;
              }
              break;
            case 5:
              if (x.is_active) {
                this.manageBuildingMasterData = x;
                this.manageBuildingFormActive = true;
              }
              break;  
            case 6:
              if (x.is_active) {
                this.rspManagementMasterData = x;
                this.rspManagementFormActive = true;
              }
              break; 
          }
        }
      }
    },
    async uploadFile(file) {
      let formData = new FormData();
      formData.append("files[]", file);
      let res = await this.$apiFire("Attachment/uploadFile", formData);
      console.log("res@uploadFile", res);
      if (res && res.length > 0) {
        console.log("file uploaded", res[0]);
        return res[0];
      } else {
        return 0;
      }
    },
    async retrieveMainProject() {
      let res = await this.$apiFire(
        "MainProject/getMainProject",
        this.$route.params.id
      );
      console.log("retrieveMainProject", res);
      if (res) {
        this.form = res;
        this.startDate = res.start_date.split(" ")[0];
        this.startTime = res.start_date.split(" ")[1];
        this.endDate = res.end_date.split(" ")[0];
        this.endTime = res.end_date.split(" ")[1];

        this.servicePlatformForm = res.plan.find((x) => x.plan_master_id === 1);
        if(this.servicePlatformForm){
          
          if (this.servicePlatformForm.evaluate_layout_id) {
            this.servicePlatformForm.selected_evaluate_layout_id = this.servicePlatformForm.evaluate_layout_id;
          }
          this.servicePlatformStatus = 'Active'
        }
        eventBus.$emit(
          "mainProjectFormServicePlatform",
          this.servicePlatformForm
        );

        this.irtcForm = res.plan.find((x) => x.plan_master_id === 2);
        if(this.irtcForm){
          
          if (this.irtcForm.evaluate_layout_id) {
            this.irtcForm.selected_evaluate_layout_id = this.irtcForm.evaluate_layout_id;
          }
          this.irtcStatus = 'Active'
        }
        eventBus.$emit("mainProjectFormIRTC", this.irtcForm);

        this.stiForm = res.plan.find((x) => x.plan_master_id === 3);
        if(this.stiForm){
          
          if (this.stiForm.evaluate_layout_id) {
            this.stiForm.selected_evaluate_layout_id = this.stiForm.evaluate_layout_id;
          }
          this.stiStatus = 'Active'
        }
        eventBus.$emit("mainProjectFormSTI", this.stiForm);

        this.collaborativeForm = res.plan.find((x) => x.plan_master_id === 4);
        if(this.collaborativeForm){
          
          if (this.collaborativeForm.evaluate_layout_id) {
            this.collaborativeForm.selected_evaluate_layout_id = this.collaborativeForm.evaluate_layout_id;
          }
          this.collaborativeStatus = 'Active'
        }
        eventBus.$emit("mainProjectFormCollaborative", this.collaborativeForm);

        this.manageBuildingForm = res.plan.find((x) => x.plan_master_id === 5);
        if(this.manageBuildingForm){
          
          if (this.manageBuildingForm.evaluate_layout_id) {
            this.manageBuildingForm.selected_evaluate_layout_id = this.manageBuildingForm.evaluate_layout_id;
          }
          this.manageBuildingStatus = 'Active'
        }
        eventBus.$emit("mainProjectFormManageBuilding", this.manageBuildingForm);

        this.rspManagementForm = res.plan.find((x) => x.plan_master_id === 6);
        if(this.rspManagementForm){
          
          if (this.rspManagementForm.evaluate_layout_id) {
            this.rspManagementForm.selected_evaluate_layout_id = this.rspManagementForm.evaluate_layout_id;
          }
          this.rspManagementStatus = 'Active'
        }
        eventBus.$emit("mainProjectFormRSPManagement", this.rspManagementForm);
      }
    },

    generateYearList() {
      const currentYear = new Date().getFullYear(); // ค.ศ.
      const yearList = [];

      for (let year = currentYear - 5; year <= currentYear + 5; year++) {
        yearList.push(year + 543); // แปลงเป็น พ.ศ.
      }

      this.yearList = yearList;
    },

    getIsYearSelect() {
      const status = this.form.status;
      const id = this.$route.params.id;

      console.log("getIsYearSelect", this.form.status, id);

      if (status === "Draft" || !id) {
        this.isYearSelect = true;
      } else {
        this.isYearSelect = false;
      }
    }
  },
};
</script>

<style scoped lang="scss"></style>
